export default "__VITE_ASSET__GqNIQQxX__"